import script from "./AdsTxtDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdsTxtDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AdsTxtDashboard.vue?vue&type=style&index=0&id=3947f23e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3947f23e"]])

export default __exports__